"use strict";
/**
 * @file Created on 02/14/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ResourceLockDTOConverter_1 = require("./conversions/ResourceLockDTOConverter");

var ResourceLockDTOConverterImpl_1 = require("./conversions/ResourceLockDTOConverterImpl");

var ResourceLockResultDTOConverter_1 = require("./conversions/ResourceLockResultDTOConverter");

var ResourceLockResultDTOConverterImpl_1 = require("./conversions/ResourceLockResultDTOConverterImpl");
/**
 * @author Jaroslav Sevcik
 * @author Tomas Leity
 */


var ResourceLockAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ResourceLockAppModule, _AppModule_1$AppModul);

  function ResourceLockAppModule() {
    var _this;

    _classCallCheck(this, ResourceLockAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'ResourceLockAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ResourceLockAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ResourceLockDTOConverter_1.ResourceLockDTOConverter).to(ResourceLockDTOConverterImpl_1.ResourceLockDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ResourceLockResultDTOConverter_1.ResourceLockResultDTOConverter).to(ResourceLockResultDTOConverterImpl_1.ResourceLockResultDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ResourceLockAppModule;
}(AppModule_1.AppModule);

exports.ResourceLockAppModule = ResourceLockAppModule;